import { useSetSearchParams } from '@hook/useSetSearchParams';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ResultWrapFavorite = ({ activeFavorite }: { activeFavorite: string | null }) => {
    const { t } = useTranslation();
    const setParams = useSetSearchParams();
    const [isFav, isFavSet] = useState(false);

    useEffect(() => {
        activeFavorite && isFavSet(activeFavorite === 'true');
    }, [activeFavorite]);

    const onFavClick = () => {
        if (!isFav && window.isLoginFlag !== 'true') {
            window.GNBLogin?.();
            return false;
        }
        setParams({ favorite: (!isFav).toString(), page: '' });
        isFavSet(!isFav);
    };

    return (
        <button data-name="btn-favorite" data-areas="시세_리스트_즐겨찾기필터_클릭" onClick={onFavClick}>
            <i className={classNames({ 'is-active': isFav }, 'ico-favorite')} /> {t('common.viewfavorites')}
        </button>
    );
};
